import { ComRateio, TEXTO_DO_CRITERIO, fmtPercentual } from './rateioDoGrupo';
import { EstadoDoMotor, situacaoDaSimulacao } from './motorDoRateio';

/**
 * A LINHA DE RESUMO DO RATEIO no grupo de Grupos Econômicos (10/10/2026). O grupo aberto mostrava tudo de uma vez, com
 * a divisão DUAS vezes; agora fica uma linha, e o detalhe mora na gaveta do rateio:
 *
 *   divide R$ 512,30 · por ramais contratados · 68,89% / 31,11% · motor ligado · simulação válida
 *
 * - Até 3 empresas, os percentuais na ordem da divisão; mais que isso, "N empresas" (a FESTVAL tem 37).
 * - Motor e simulação vêm do GET /rateio/motor, que é ADMIN: sem ele (não-admin, ou leitura que não chegou), a linha
 *   OMITE os dois. Nunca diz "desligado" sem ter lido.
 * - As notícias ficam NA LINHA: a soma que não fecha e a base que mudou. Antes moravam dentro dos painéis.
 */
export interface ResumoDoRateio {
  partes: string[];
  alertas: Array<{ texto: string; tom: 'danger' | 'warning' }>;
}

const brl = (v: number) => `R$ ${Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function resumoDoRateio(r: ComRateio, motor: EstadoDoMotor | null): ResumoDoRateio {
  const partes: string[] = [`divide ${brl(r.pool)}`, TEXTO_DO_CRITERIO[r.criterio] || r.criterio];
  partes.push(r.linhas.length <= 3 ? r.linhas.map((l) => fmtPercentual(l.percentualVigente)).join(' / ') : `${r.linhas.length} empresas`);
  if (motor) {
    partes.push(motor.motor.ativo ? 'motor ligado' : 'motor desligado');
    if (motor.temRateio) {
      const s = situacaoDaSimulacao(motor.dryRun.vencido);
      partes.push(s === 'valida' ? 'simulação válida' : s === 'vencida' ? 'simulação vencida' : 'sem simulação');
    }
  }
  const alertas: ResumoDoRateio['alertas'] = [];
  if (!r.somaVigenteFecha) alertas.push({ texto: `a divisão soma ${fmtPercentual(r.somaVigente)}, não 100%`, tom: 'danger' });
  if (r.divergente) alertas.push({ texto: 'a base mudou: a divisão foi acordada com outra contagem', tom: 'warning' });
  return { partes, alertas };
}
